(ns motorsaif.time
  (:refer-clojure :exclude [format])
  #?(:cljs
     (:import
      (goog.i18n NumberFormat)
      (goog.i18n.NumberFormat Format)))
  (:require
   [taoensso.encore :as encore]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.string :as string :refer [format]]
   #?@(:clj [[clj-time.coerce :as time-coerce]
             [clj-time.core :as time-core]
             [clj-time.format :as time-format]]
       :cljs [[cljs-time.coerce :as time-coerce]
              [cljs-time.core :as time-core]
              [cljs-time.format :as time-format]
              [goog.dom.ViewportSizeMonitor]
              [goog.string]])))

(defn to-long [t]
  (time-coerce/to-long t)
  )

(defn normalize-time [d]
  (cond
    ;; (= java.util.Date (class d)) (time-coerce/from-date d)
    (inst? d) (time-coerce/from-date d)
    (string? d) (time-coerce/from-long (encore/as-int d))
    (number?  d) (time-coerce/from-long d)
    :else d))

(defn after?
  "Return true if d1 is later than d2"
  [d1 d2]
  (assert (inst? d1) (str "D1 not inst: " d2))
  (assert (inst? d2) (str "D2 not inst: " d2))

  (time-core/after? (normalize-time d1) (normalize-time d2)))

(defn before?
  "Return true if d1 is earlier than d2"
  [d1 d2]
  (time-core/before? (normalize-time d1) (normalize-time d2))
  )

(defn stamp
  "Return the number of milliseconds from epoch of now"
  []
  #?(:clj (System/currentTimeMillis)
     :cljs (.getTime (js/Date.))))

(defn date
  "Return the number of milliseconds from epoch of now"
  ([]
   #?(:clj  (java.util.Date.)
      :cljs (js/Date.)))
  ([ts]
   #?(:clj  (java.util.Date. ts)
      :cljs (js/Date. ts))))

(defn ago-data [timestamp]
  (let [now      (stamp)
        delta    (- now timestamp)
        seconds  (quot delta 1000)
        minutes  (quot delta 60000)
        hours    (quot delta 3600000)
        days     (quot delta 86400000)
        time-ago (cond
                   (> days     1) [days "days"]
                   (= days     1) [days "day"]
                   (> hours    1) [hours "hours"]     ; (format "%d hours" hours)
                   (>= minutes 2) [minutes "minutes"] ; (format "%d minutes" minutes)
                   (>= minutes 1) [minutes "minute"]  ; (format "%d minute" minutes)
                   (> seconds  1) [seconds "secs"]    ; (format "%d secs" seconds)
                   :else          [nil "Just now"])]
    time-ago))

(defn ago-str [timestamp]
  (let [now      (stamp)
        delta    (- now timestamp)
        seconds  (quot delta 1000)
        minutes  (quot delta 60000)
        hours    (quot delta 3600000)
        days     (quot delta 86400000)
        time-ago (cond
                   (> days    1)  (format "%d days ago" days)
                   (= days    1)  (format "%d day ago" days)
                   (= hours    1) (format "%d hour ago" hours)
                   (> hours    1) (format "%d hours ago" hours)
                   (>= minutes 2) (format "%d minutes ago" minutes)
                   (>= minutes 1) (format "%d minute ago" minutes)
                   (> seconds  1) (format "%d secs ago" seconds)
                   :else          "Just now")]
    time-ago))

(defn tr-ago-str [timestamp]
  (let [now      (stamp)
        delta    (- now timestamp)
        seconds  (quot delta 1000)
        minutes  (quot delta 60000)
        hours    (quot delta 3600000)
        days     (quot delta 86400000)
        time-ago (cond
                   (> days    1)  (tr [:time-ago.days] [days] "%1 day ago")
                   (= days    1)  (tr [:time-ago.day] [days] "%1 days ago")
                   (= hours    1) (tr [:time-ago.hour] [hours] "%1 hour ago")
                   (> hours    1) (tr [:time-ago.hours] [hours] "%1 hours ago")
                   (>= minutes 2) (tr [:time-ago.minutes] [minutes] "%1 minute ago")
                   (>= minutes 1) (tr [:time-ago.minute] [minutes] "%1 minutes ago")
                   (> seconds  1) (tr [:time-ago.seconds] [seconds] "%1 secs ago")
                   :else          (tr [:time-ago.just-now] "Just now"))]
    time-ago))
(comment
  (ago-str (- (stamp) (encore/ms :mins 10)))
  (ago-str (- (stamp) (encore/ms :mins 59)))
  (ago-str (- (stamp) (encore/ms :mins 120)))
  (ago-str (- (stamp) (encore/ms :mins 99))))


#?(:cljs
   (do
     (defn inst->day-of-week [inst]
       (let [days [:sun :mon :tue :wed :thu :fri :sat]]
         (get days ^js (.getDay inst))))

     (defn inst->weekend? [inst]
       (if (#{:sat :sun} (inst->day-of-week inst)) true false))

     (def ^:private nff
       (NumberFormat. Format/DECIMAL))

     (defn int-comma
       [num]
       (.format nff (str num)))))

(defn time->ms
  [t]
  (time-coerce/to-long (normalize-time t)))

(defn ms->inst [ms]
  (time-coerce/to-date (time-coerce/from-long ms)))

(defn inst->ms [inst]
  (time-coerce/to-long (time-coerce/from-date inst)))


(defn stamp-plus
  [& args]
  (+
   (stamp)
   (apply encore/ms args)))

(defn date-plus
  [d1 & args]
  (date
   (+
    (inst->ms d1)
    (apply encore/ms args))))

(defn date-minus
  [& args]
  (date
   (-
    (stamp)
    (apply encore/ms args))))

(comment
  [(date)

   (-
    (inst->ms (normalize-time (date)))
    (time-coerce/to-long (normalize-time (date-minus :mins 5))))

   (before?
    (time-coerce/to-date (date-minus :mins 5))
    (time-coerce/to-date (date)))

   (minus
    (date)
    (date-minus :mins 3))

   (date-minus :secs 3)])


;; TODO: Fix when expanding outside UAE
;;

(defn minus "Get ms between two times"
  [t1 t2]
  (-
   (time->ms t1)
   (time->ms t2))
  )


(defn date->format
  "https://github.com/andrewmcveigh/cljs-time/blob/master/src/cljs_time/format.cljs"
  [udt time-format]
  #?(:clj
     (time-format/unparse (time-format/formatter time-format
                                                 (time-core/time-zone-for-id "Asia/Dubai"))
                          (time-coerce/from-long udt)))

  #?(:cljs
     (time-format/unparse (time-format/formatter time-format)
                          (time-coerce/from-long (+ (time-coerce/to-long udt)
                                                    (encore/ms :hours 4))))
     #_(time-format/unparse (time-format/formatter time-format) (time-core/to-default-time-zone udt (time-coerce/from-long udt)))))

(defn days-elapsed
  ([inst]
   (days-elapsed inst (date)))
  ([inst1 inst2]
   (let [d1 (time-coerce/from-date inst1)
         d2 (time-coerce/from-date inst2)]
     (when (time-core/after? d2 d1)
       (time-core/in-days
        (time-core/interval
         d1
         d2))))))

(defn udt->format
  "https://github.com/andrewmcveigh/cljs-time/blob/master/src/cljs_time/format.cljs"
  [udt time-format]
  (time-format/unparse (time-format/formatter time-format) (time-coerce/from-long udt)))


#?(:clj
   (defn granular-date
     "Returns an inst with the lower at the specific granular level. Specificty can be #{:month :day :hour}"
     ([specificity]
      (granular-date specificity (stamp)))
     ([specificity date]
      (assert (some #{:month :day :hour :min :week} [specificity]))
      (let [formatter-str (condp = specificity
                            :month "MM/yy"
                            :week "w/yy"
                            :day "dd/MM/yy"
                            :hour "dd/MM/yy H"
                            :min "dd/MM/yy H m")
            formatter (clj-time.format/formatter formatter-str)]
        (time-coerce/to-date
         (clj-time.format/parse formatter (udt->format date formatter)))))))

(defn default-ago-str-date
  ""
  [date]
  (when date
    (format "%s | %s " (date->format date "MMM d YYYY") (ago-str date))))
